// extracted by mini-css-extract-plugin
module.exports = {"container":"InteractiveAreaCanvas_container__3IXsd"};